import { useAppLoad } from "../../appLoadContext";
import { AppLoad } from "@ploy-lib/types";

import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { Typography } from "@material-ui/core";
import { DployContextStore, legacyApiResourceUrl } from "@ploy-lib/core";

addRegisteredSectionLayout({
	name: "DownloadTermsSection",
	displayName: "DownloadTermsSection",
	settings: {
		editableOptions: {
			allowEditSameSession: true
		}
	}
});

function fixMojibake(str) {
	// Replace common UTF-8/Latin-1 mixups
	return str
		.replace(/Ã¥/g, "å")
		.replace(/Ã¸/g, "ø")
		.replace(/Ã¦/g, "æ")
		.replace(/Ã…/g, "Å")
		.replace(/Ã˜/g, "Ø")
		.replace(/Ã†/g, "Æ");
}

const downloadTermsDocument = async (link: string) => {
	try {
		const headers = {
			Accept: "application/json;application/pdf",
			...(DployContextStore.context ?? {})
		};

		const res = await fetch(legacyApiResourceUrl(link), {
			method: "GET",
			headers
		});

		if (!res.ok) {
			throw new Error("Failed to fetch file");
		}

		// get filename from Content-Disposition header if present
		let fileName = "loanterms";
		const disposition = res.headers.get("Content-Disposition");

		// Translate from utf-8 to latin-1...
		if (disposition && disposition.includes("filename=")) {
			const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
			if (match && match[1]) {
				const rawName = match[1].replace(/['"]/g, "");
				//
				const bytes = Uint8Array.from(rawName, ch => ch.charCodeAt(0) & 0xff);
				fileName = new TextDecoder("utf-8").decode(bytes);
				fileName = fixMojibake(fileName);
			}
		}
		// make blob URL

		const blob = await res.blob();
		const blobUrl = URL.createObjectURL(blob);
		const url = document.createElement("a");
		url.href = blobUrl;
		url.download = fileName;
		document.body.appendChild(url);
		url.click();
		document.body.removeChild(url);

		setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
	} catch (err) {
		console.error("Error downloading/opening file:", err);
	}
};

const DownloadTermsSection = () => {
	const appload = useAppLoad();
	const productId = appload.productId;
	const { hasTermsDocument, termsDocumentName, productInfoId } =
		appload.settings.productTermsSettings;

	if (!hasTermsDocument) {
		return null;
	}

	const link = `/Product/GetProductInfoById?productId=${productId}&productInfoId=${productInfoId}`;
	return (
		<Typography
			onClick={() => {
				downloadTermsDocument(link);
			}}
			style={{
				fontSize: "18px",
				textDecoration: "underline",
				alignContent: "center",
				cursor: "pointer",
				fontWeight: 700,
				display: "block",
				textAlign: "center"
			}}
			variant="h1"
		>
			{termsDocumentName || "Avtalevilkår"}
		</Typography>
	);
};

export { DownloadTermsSection };
